"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const custom_filter_1 = require("components/atoms/custom-filter");
const HopperColumnProps = [
    {
        show: true,
        field: 'ticket_no',
        title: 'Ticket No',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'checkpoint_name',
        title: 'Line Hopper',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'gate_in',
        title: 'Date',
        width: '150',
        filter: 'date',
        format: constants_1.formatGridDate.ddMMyyyy
    },
    {
        show: true,
        field: 'queue_time',
        title: 'Queue Time In',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'gate_in',
        title: 'Time In',
        width: '150',
        filterCell: custom_filter_1.FilterTImePicker,
        format: constants_1.formatGridDate.hhMMss
    },
    {
        show: true,
        field: 'gate_out',
        title: 'Time Out',
        width: '150',
        filterCell: custom_filter_1.FilterTImePicker,
        format: constants_1.formatGridDate.hhMMss
    },
    {
        show: true,
        field: 'lead_time',
        title: 'Lead Time',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'brand_name',
        title: 'Coal Brand',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler No',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel1_no',
        title: 'Vessel 1',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'capacity_volume1',
        title: 'Capacity (Ton)',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel2_no',
        title: 'Vessel 2',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'capacity_volume2',
        title: 'Capacity (Ton)',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'total_volume',
        title: 'Total Capacity (Ton)',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'dumping_hopper',
        title: 'Dumping Hopper',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'driver_name',
        title: 'Driver Name',
        width: '150',
        filter: 'text'
    }
];
exports.default = HopperColumnProps;
